import React from 'react';
import useDocumentMetadata from '../hooks/useDocumentMetadata';

const TermsOfService = () => {
  useDocumentMetadata(
    'Terms of Service - Dakhla',
    'Review the Terms of Service for using Dakhla, Pakistan\'s university admissions and directory portal.'
  );

  return (
    <div className="min-h-screen bg-slate-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-sm border border-slate-200/80 p-8 sm:p-12">
        {/* Header */}
        <div className="border-b border-slate-100 pb-8 mb-8">
          <div className="text-sm font-bold uppercase tracking-wider text-primary-600 mb-2">
            Legal Terms
          </div>
          <h1 className="text-3xl sm:text-4xl font-extrabold text-slate-900 tracking-tight">
            Terms of Service
          </h1>
          <p className="mt-2 text-slate-500 text-sm">
            Last Updated: July 2026 • Governing terms for Dakhla users and educational partners in Pakistan.
          </p>
        </div>

        {/* Terms Content */}
        <div className="prose prose-slate max-w-none space-y-8 text-slate-700 leading-relaxed">
          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3">
              1. Acceptance of Terms
            </h2>
            <p>
              By accessing or using Dakhla (dakhla.pk), you agree to be bound by these Terms of Service. If you do not agree to these terms, you should not access or use the platform.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3">
              2. Scope of Service & Platform Role
            </h2>
            <p>
              Dakhla serves as an educational search directory and application portal for higher education institutions in Pakistan. 
            </p>
            <ul className="list-disc pl-6 space-y-2 mt-2">
              <li><strong>Official Partner Institutions:</strong> Verified universities offering direct application processing through Dakhla.</li>
              <li><strong>Public Information Entries:</strong> Independent directory listings compiled from publicly available university prospectuses and official announcements to assist students.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3">
              3. Information Disclaimer & Verification Notice
            </h2>
            <p>
              While Dakhla endeavors to maintain accurate and up-to-date information regarding eligibility criteria, fee structures, and application deadlines, university policies may change rapidly. Students are advised to verify critical deadlines and admission requirements with official university prospectuses or administration offices.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3">
              4. User Account & Responsibilities
            </h2>
            <p>
              Users must provide truthful and accurate academic information. Submitting fraudulent test scores or false educational credentials may result in application cancellation and account suspension.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3">
              5. Intellectual Property & Trademarks
            </h2>
            <p>
              All university names, logos, insignia, and trademarks displayed on Dakhla remain the property of their respective trademark holders. Usage on Dakhla is strictly nominative for identification and educational reference.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3">
              6. Governing Law & Jurisdiction
            </h2>
            <p>
              These Terms shall be governed by and construed in accordance with the laws of the Islamic Republic of Pakistan. Any disputes arising hereunder shall be subject to the jurisdiction of competent courts in Pakistan.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
